export const ORDER_STATUS = {
  NEW: "سفارش جدید",
  WAREHOUSE: "ارسال به انبار",
  EDITED: "ویرایش و ارسال به مشتری",
  POSTED: "ارسال به مشتری",
  CONFIRMED: "تایید نهایی",
  CONFIRMED_LEGACY: "تایید شده",
  CREDIT_PAYMENT: "پرداخت اعتباری",
};

export const isNewOrderStatus = (status) => status === ORDER_STATUS.NEW;

export const isPostedOrderStatus = (status) =>
  status === ORDER_STATUS.POSTED || status === ORDER_STATUS.EDITED;

export const isWarehouseOrderStatus = (status) => status === ORDER_STATUS.WAREHOUSE;

export const isOngoingPayableStatus = (status) =>
  isNewOrderStatus(status) ||
  isPostedOrderStatus(status) ||
  isWarehouseOrderStatus(status);

export const isConfirmedOrderStatus = (status) =>
  status === ORDER_STATUS.CONFIRMED ||
  status === ORDER_STATUS.CONFIRMED_LEGACY ||
  status === ORDER_STATUS.CREDIT_PAYMENT;
